module.exports = __webpack_public_path__ + "img/collection-diamondJewelry050Carat.357fda1.jpg";